import { getAccountsStyles } from './variantStyles/accounts';
import { getCreditCardsStyles } from './variantStyles/creditCards';
import { getDebitCardsStyles } from './variantStyles/debitCards';
import { getDepositsStyles } from './variantStyles/deposits';
import { getInsurancesStyles } from './variantStyles/insurances';
import { getLoansStyles } from './variantStyles/loans';
import { getMortgagesStyles } from './variantStyles/mortgages';
import { getRegularStyles } from './variantStyles/regular';
import { getWealthStyles } from './variantStyles/wealth';
export const getProductCardStyles = (FOUNDATIONS, FONT) => ({
    // deprecated regular variant
    ...getRegularStyles(FOUNDATIONS),
    // ! accounts is equal to wealth in styles
    ...getAccountsStyles(FOUNDATIONS),
    ...getCreditCardsStyles(FOUNDATIONS),
    ...getDebitCardsStyles(FOUNDATIONS),
    // ! deposits, loans, insurances and mortgages are equal in styles
    ...getDepositsStyles(FOUNDATIONS),
    ...getInsurancesStyles(FOUNDATIONS),
    ...getLoansStyles(FOUNDATIONS),
    ...getMortgagesStyles(FOUNDATIONS),
    // ! wealth changes just in margin_bottom from center bar
    ...getWealthStyles(FOUNDATIONS),
});
//# sourceMappingURL=styles.js.map